import { render, staticRenderFns } from "./ContactTab.component.vue?vue&type=template&id=5f3362ca&scoped=true&"
import script from "./ContactTab.component.vue?vue&type=script&lang=js&"
export * from "./ContactTab.component.vue?vue&type=script&lang=js&"
import style0 from "./ContactTab.component.vue?vue&type=style&index=0&id=5f3362ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3362ca",
  null
  
)

export default component.exports